<!-- <img src="/assets/images/Brooklynlogo.png"  class="p-1" /> -->
<div nz-row class="center p-3">
      <div nz-col nzSpan="12" nzOffset="6" class="splitbox mobile-none">
            <img class="login-right-img" src="/assets/images/404-Error.png" />
            <p class="p-1">The page you're looking for cannot be found. please check the page you're trying to access.</p>
            <button nz-button (click)="this.location.back()" [nzType]="'primary'" style="display: unset;">Back to Last
                  Page</button>
      </div>
</div>